import React, { useContext, useEffect } from 'react'

import Form from '../../../elem/form/Form'
import FormResultsSummary from '../../../elem/form/FormResultsSummary'
import { DataContext } from './DataContext'
import getFilterParamsFromForm from '../../../../utils/form/getFilterParamsFromForm'
import clearFormFields from '../../../../utils/form/clearFormFields'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

const Filter = ({ filterExpanded, syncFilterState, isSectionCollapsible }) => {
    const { width } = useContext(PanelStyleContext)
    const {
        filterFields,
        fetchFilterFields,
        fetchResultsCount,
        filterResultsCount,
        filterResultsLoading,
        params,
        setParams,
        setStoredParams,
        setRefinedParams,
        formName,
    } = useContext(DataContext)

    const onSubmit = (data, e) => {
        const newParams = {
            PageSize: 50,
            Page: 1,
            SortByField: params['sample'].SortByField,
            SortOrder: params['sample'].SortOrder,
            ...getFilterParamsFromForm(data),
        }
        setParams(newParams, 'sample')
        syncFilterState(false)
    }

    const onReset = (getValues, setValue, clearStoredParams = true) => {
        clearFormFields(getValues, setValue)
        const newParams = {
            PageSize: 50,
            Page: 1,
            SortByField: params['sample'].SortByField,
            SortOrder: params['sample'].SortOrder,
        }
        setParams(newParams, 'sample')
        if (clearStoredParams) {
            setStoredParams([])
            setRefinedParams([])
        }
    }

    const addToResults = (data, resetForm) => {
        // const newParams = {
        //     PageSize: 50,
        //     Page: 1,
        //     SortByField: params['sample'].SortByField,
        //     SortOrder: params['sample'].SortOrder,
        //     ...getFilterParamsFromForm(data, false),
        // }
        setStoredParams(prev => [
            ...prev,
            { sample: getFilterParamsFromForm(data, false) },
        ])
        resetForm()
    }

    const refineResults = (data, resetForm) => {
        // const newParams = {
        //     PageSize: 50,
        //     Page: 1,
        //     SortByField: params['sample'].SortByField,
        //     SortOrder: params['sample'].SortOrder,
        //     ...getFilterParamsFromForm(data, false),
        // }
        setRefinedParams(prev => [
            ...prev,
            { sample: getFilterParamsFromForm(data, false) },
        ])
        resetForm()
    }

    useEffect(() => {
        fetchFilterFields()
    }, [])

    return (
        <>
            <FormResultsSummary
                name={formName}
                filterResultsCount={filterResultsCount}
                filterResultsLoading={filterResultsLoading}
                filterExpanded={filterExpanded}
            />
            <div
                className={`explorerFilter ${
                    filterExpanded ? 'is-visible' : 'is-hidden'
                }`}
            >
                <div className="content">
                    <Form
                        formWidth={width}
                        formName={formName}
                        formFields={filterFields}
                        onSubmit={onSubmit}
                        onReset={onReset}
                        onChange={fetchResultsCount}
                        addToResults={addToResults}
                        refineResults={refineResults}
                        params={params}
                        isSectionCollapsible={isSectionCollapsible}
                    />
                </div>
            </div>
        </>
    )
}

export default Filter
